import SKEventModel from 'Models/SKEventModel';

export function handleFallbackImg(event) {
  if (event.target.parentNode.tagName === 'PICTURE') {
    [...event.target.parentNode.querySelectorAll('source')].forEach((sourceNode) => {
      sourceNode.remove();
    });
  }

  const fallbackSrc = event.target.getAttribute('data-fallback-img');
  if (fallbackSrc && event.target.src !== fallbackSrc) {
    event.target.src = fallbackSrc;
  }
}

export function getLazySrc(src) {
  const srcObject = {};

  srcObject['data-src'] = this.$isSSR ? src : '';
  srcObject.src = this.$isSSR
    // eslint-disable-next-line max-len
    ? 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
    : src;

  return srcObject;
}

export const _skGlobal = {
  handleFallbackImg,
  EVENTS: SKEventModel,
};
